import { defineComponent, h, VNode } from 'vue';

export default defineComponent({
  name: 'VContainer',
  render(): VNode {
    return h('div', { class: 'container' }, this.$slots.default?.());
  },
});
